export default __webpack_public_path__ + "static/media/minus.62aa22b7.svg";